import {
  ROOT,
  GET_GATEWAY_INFO,
  GET_PAYMENT_GATE,
  GET_PARAM_PAYMENT,
  GET_SETTING_PAYMENT,
  UPDATE_PAYMENT_GATE,
  REGIS_PAYMENT_ONLINE,
  GET_GATEWAY_CONFIG,
  UPDATE_PARAM,
  DEATIVE_METHOD
} from "@/_helpers/constant.js";
import { BehaviorSubject } from "rxjs";
import { requestOptions, handleResponse } from "@/_helpers";

function getGatewayInfo() {
  return fetch(ROOT + GET_GATEWAY_INFO, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function regisPaymentOnline() {
  return fetch(ROOT + REGIS_PAYMENT_ONLINE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getPaymentGate() {
  return fetch(ROOT + GET_PAYMENT_GATE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getParamPayment(id) {
  return fetch(ROOT + GET_PARAM_PAYMENT + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getSettingPayment(id) {
  return fetch(ROOT + GET_SETTING_PAYMENT + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_PAYMENT_GATE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getGatewayConfig() {
  return fetch(ROOT + GET_GATEWAY_CONFIG, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateParam(data) {
  return fetch(ROOT + UPDATE_PARAM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deativeMethod(code) {
  return fetch(ROOT + DEATIVE_METHOD + `/${code}`, requestOptions.post())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const service = {
  getGatewayInfo,
  getPaymentGate,
  getParamPayment,
  getSettingPayment,
  update,
  regisPaymentOnline,
  getGatewayConfig,
  updateParam,
  deativeMethod
};
